import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartReact from "highcharts-react-official";
import { BasicChartProps } from "./types";

export const BasicStockChart = React.forwardRef(
  ({ height = 500, immutable = false, options, style }: BasicChartProps, ref: any) => {
    style = {
      height,
      ...style
    };

    return (
      <HighchartReact
        ref={ref}
        highcharts={Highcharts}
        constructorType={"stockChart"}
        immutable={immutable}
        options={{
          credits: false,
          exporting: { enabled: false },
          ...options
        }}
        containerProps={{ style }}
      />
    );
  }
);
